import ReactPDF from '@react-pdf/renderer'
import styles from './styles'
import { PX_TO_PT } from '../../../utils/constants'

// @react-pdf/renderer lacks a 'px' parser case and silently defaults to 'pt',
// rendering text ~33% oversized. Explicitly map px -> pt before building styles.

const pxToPt = (value: string): string =>
  value.replace(/(-?\d*\.?\d+)px/g, (_, num) => `${parseFloat(num) * PX_TO_PT}pt`)

const convertPxValues = (style: Record<string, unknown>): Record<string, unknown> => {
  const converted: Record<string, unknown> = {}
  Object.entries(style).forEach(([property, value]) => {
    converted[property] = typeof value === 'string' ? pxToPt(value) : value
  })
  return converted
}

const compose = (classes): ReactPDF.Styles => {
  const css: ReactPDF.Styles = {}

  const classesArray = classes.replace(/\s+/g, ' ').split(' ')

  classesArray.forEach((className) => {
    if (styles[className]) {
      Object.assign(css, convertPxValues(styles[className]))
    }
  })

  return css
}

export default compose
